export const panelSizes = {
    COLLAPSED: 84,
    FULL: 280,
} as const

export const tagVariants = {
    SUCCESS: 'success',
    INFO: 'info',
} as const
